var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFollowNaoEntregue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6357 8.06822V8.00349C36.618 7.95849 36.5964 7.9152 36.571 7.87404L36.5224 7.80931L36.4254 7.70413L36.3687 7.65558L36.2635 7.60704H36.2231L18.6496 0.422294C18.455 0.34361 18.2374 0.34361 18.0428 0.422294L0.509728 7.48567H0.469275L0.364093 7.53422L0.307457 7.58277L0.210365 7.68795L0.161818 7.75267C0.136433 7.79384 0.114791 7.83712 0.0970917 7.88213V7.94686C0.0885963 8.01401 0.0885963 8.08197 0.0970917 8.14913V14.6219C0.0974307 18.4746 -5.82842e-05 21.5835 2.62037e-08 25.1158V28.4978C0.00161821 28.8245 0.199543 29.1181 0.501638 29.2422L18.0428 36.524C18.1305 36.5588 18.2236 36.5779 18.3179 36.5806C18.4121 36.5779 18.5053 36.5588 18.5929 36.524L36.1341 29.2422C36.4362 29.1181 36.6341 28.8245 36.6357 28.4978V8.27049C36.6442 8.20334 36.6442 8.13538 36.6357 8.06822ZM18.6164 2.33907L24.1699 4.72667L9.58852 10.8523L3.76806 8.52054L18.6164 2.33907ZM17.2344 34.2998L1.89251 27.6814V25.1077C1.89251 19.1123 1.89251 16.9201 1.89251 14.7271V9.72609L7.79966 12.2828L17.2344 16.3283V34.2998ZM18.3502 14.4123L11.9584 11.7342L26.556 5.58431L33.1824 8.52863L24.0786 12.2998L18.3502 14.4123ZM19.4255 34.2998V16.3283L23.7064 14.435L34.7594 9.70991L34.7998 27.6814L19.4255 34.2998Z",
    fill: "#D59B00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6406,
    cy: 28,
    r: 9,
    fill: "white",
    stroke: "#D49B00",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6772 30.2631C40.0677 30.6537 40.0677 31.2868 39.6772 31.6774C39.2867 32.0679 38.6535 32.0679 38.263 31.6774L32.707 26.1213C32.3164 25.7308 32.3164 25.0976 32.707 24.7071C33.0975 24.3166 33.7306 24.3166 34.1212 24.7071L39.6772 30.2631Z",
    fill: "#DDAF33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2631 24.7095C38.6537 24.319 39.2868 24.319 39.6774 24.7095C40.0679 25.1 40.0679 25.7332 39.6774 26.1237L34.1213 31.6798C33.7308 32.0703 33.0976 32.0703 32.7071 31.6798C32.3166 31.2892 32.3166 30.6561 32.7071 30.2655L38.2631 24.7095Z",
    fill: "#DDAF33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFollowNaoEntregue);
export default __webpack_public_path__ + "static/media/icon-follow-nao-entregue.65314ec36f3c4d24ae15e20153da60d8.svg";
export { ForwardRef as ReactComponent };